export default "__VITE_ASSET__pba60dEF__"